var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 261.76 226.69"
    }
  }, _vm.$listeners), [_c('path', {
    attrs: {
      "d": "M161.096.001l-30.225 52.351L100.647.001H-.005l130.877 226.688L261.749.001z",
      "fill": "#41b883"
    }
  }), _c('path', {
    attrs: {
      "d": "M161.096.001l-30.225 52.351L100.647.001H52.346l78.526 136.01L209.398.001z",
      "fill": "#34495e"
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }